import { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WaitlistModal from './components/WaitlistModal';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Security from './pages/Security';

function App() {
  const [isWaitlistOpen, setIsWaitlistOpen] = useState(false);
  const [modalType, setModalType] = useState('waitlist'); // 'waitlist' or 'demo'

  const handleWaitlistClick = () => {
    setModalType('waitlist');
    setIsWaitlistOpen(true);
  };

  const handleDemoClick = () => {
    setModalType('demo');
    setIsWaitlistOpen(true);
  };

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App">
        <Navbar 
          onWaitlistClick={handleWaitlistClick}
          onDemoClick={handleDemoClick}
        />
        <Routes>
          <Route path="/" element={<Home onWaitlistClick={handleWaitlistClick} onDemoClick={handleDemoClick} />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/security" element={<Security />} />
        </Routes>
        <Footer />
        <WaitlistModal 
          isOpen={isWaitlistOpen} 
          onClose={() => setIsWaitlistOpen(false)}
          type={modalType}
        />
      </div>
    </BrowserRouter>
  );
}

export default App;
